import { useEffect, useState } from 'react'
import { UIModule } from '@/core/modules/ui-settings/ui-settings.module'
import { TTheme, useCustomTheme } from '@/core/theme'
import { Switch } from '@components/buttons/switch'
import ContentItem from '@components/page-content/content-item'
import Typography from '@/ui/components/typography'
import { AppearanceTitle } from './UserAppearanceToggle.styles'

const UserAppearanceToggle = () => {
    const theme = useCustomTheme() as TTheme
    const [themeName, setThemeName] = useState('light')

    useEffect(() => {
        setThemeName(localStorage.getItem('theme') || 'light')
    }, [])

    const changeAppearanceHandler = () => {
        const t = themeName === 'dark' ? 'light' : 'dark'
        UIModule.setTheme(t, true)
        setThemeName(t)
    }

    return (
        <div>
            <AppearanceTitle>
                <Typography
                    component="p"
                    variant="m-regular"
                    color={theme.colors.greys[800]}
                >
                    Appearance
                </Typography>
            </AppearanceTitle>

            <ContentItem label="Dark mode">
                <Switch
                    checked={themeName === 'dark'}
                    onChange={() => changeAppearanceHandler()}
                    text={{ on: 'Yes', off: 'No' }}
                    loading={false}
                    testId="toggle"
                />
            </ContentItem>
        </div>
    )
}

export default UserAppearanceToggle
